import React from 'react';
import styles from './loading.page.module.scss';

export const Loading: React.FC = () => {
  return (
    <div className={styles.page__container}>
      <div className={styles.loader}></div>
    </div>
  );
};
